const transfromSubCountryFromGW = (list = []) =>
    list.map(el => ({ code: el.name, label: el.value, group: el.group })).sort((a, b) => (a.label <= b.label ? -1 : 1));

export default transfromSubCountryFromGW;
